import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ExplanationService } from '../../explanation.service';
import { ExplanationMessage } from '../../explanation-message';
import { AssessmentCriteria } from '../assessment-criteria';
import { AssessmentCriteriaService } from '../assessment-criteria.service';
import { ActivatedRoute } from '@angular/router';
import { SemsoSnackbarService } from '../../../semso-snackbar.service';
import { GradeService } from 'app/examination/workprocess/grade.service';

@Component({
  selector: 'app-assessment-form',
  templateUrl: './assessment-form.component.html',
  styleUrls: ['./assessment-form.component.scss']
})
export class AssessmentFormComponent implements OnInit {
  public grade = 1;
  private examinationId;
  private workprocessCode;
  private gradeServiceSubscription;

  @Input('assessmentCriteria') assessmentCriteria: AssessmentCriteria;

  constructor(private explanationService: ExplanationService,
    private assessmentCriteriaService: AssessmentCriteriaService, private route: ActivatedRoute,
    private snackbar: SemsoSnackbarService, private gradeService: GradeService) { }

  ngOnInit() {
    this.route.params.subscribe(data => {
      this.examinationId = data.examinationId;
      this.workprocessCode = data.workprocessId;
    });

    this.assessmentCriteriaService.assessmentCriteriaError$.subscribe(data => {
      this.snackbar.error('Fout bij het versturen van het resultaat');
    });

    this.grade = this.assessmentCriteria.geselecteerdeWaarde;

    this.gradeServiceSubscription = this.gradeService.change.subscribe(setGood => {
      if (setGood && this.grade != 3) {
        this.grade = 3;
        this.updateGrade(this.grade);
      }
    });
  }

  ngOnDestroy() {
    if (this.gradeServiceSubscription !== undefined && this.gradeServiceSubscription != null) {
      this.gradeServiceSubscription.unsubscribe();
    }
  }

  updateGrade(data) {
    this.assessmentCriteriaService.postAssessmentCriteria(this.examinationId, this.workprocessCode, {
      beoordelingscriteriaId: this.assessmentCriteria.id,
      waarde: this.getGrade(data)
    }).subscribe(result => {
      this.gradeService.updateGrade(result);
    });
  }

  clear() {
    this.grade = 1;
    this.updateGrade(1);
  }

  openSideNav() {
    this.explanationService.openExplanation(this.assessmentCriteria.toelichtingPagina);
  }

  private getGrade(grade) {
    switch (grade) {
      case 1:
        return 'NietBeoordeeld';
      case 2:
        return 'Onvoldoende';
      case 3:
        return 'Voldoende';
    }
    return 'NietBeoordeeld';
  }
}



// WEBPACK FOOTER //
// ./src/app/examination/workprocess/assessment-form/assessment-form.component.ts